import { render, staticRenderFns } from "./vehicleTest.vue?vue&type=template&id=1407061e&scoped=true"
import script from "./vehicleTest.vue?vue&type=script&lang=js"
export * from "./vehicleTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407061e",
  null
  
)

export default component.exports